import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin(async (nuxtApp) => {
  if (import.meta.server) {
    nuxtApp.vueApp.directive('tooltip', {
      getSSRProps() {
        return {};
      },
    });
  }
  if (import.meta.client) {
    const { default: AtomicTooltip } = await import('@atomic-ui/tooltip/tooltip.js');
    nuxtApp.vueApp.directive('tooltip', AtomicTooltip);
  }
});
